import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    flex-direction: ${displayState?.flexDirection ?? ''};
    align-items: ${displayState?.alignItems ?? ''};
    justify-content: ${displayState?.justifyContent ?? ''};
    background-color: ${displayState?.background ?? ''};
    border-radius: ${displayState?.borderRadius ?? ''};
    border: ${displayState?.border ?? ''};
    width: ${displayState?.width ?? ''};
    height: ${displayState?.height ?? ''};
    padding: ${displayState?.padding ?? ''};
    position: ${displayState?.position ?? ''};
    left: ${displayState?.left ?? ''};
    top: ${displayState?.top ?? ''};
    z-index: ${displayState?.zIndex ?? ''};
    cursor: ${displayState?.cursor ?? ''};
    box-shadow: ${displayState?.shadow ?? ''};
  `}
`;

export default Wrapper(template);